import { and, SearchParams, SearchParamsOptions } from '@forgerock/backstage-ui-core';
import { EverythingSearchResult } from './everything-search-result';

export interface EverythingSearchParamsOptions extends SearchParamsOptions {
  aggregation?: (keyof EverythingSearchResult)[];
  groupBy?: keyof EverythingSearchResult;
  knn?: boolean;
}

export class EverythingSearchParams extends SearchParams {
  aggregation: (keyof EverythingSearchResult)[];
  groupBy?: keyof EverythingSearchResult;
  knn?: boolean;

  constructor(props?: EverythingSearchParamsOptions) {
    super(props);
    this.aggregation = props?.aggregation ?? [];
    this.groupBy = props?.groupBy;
    this.knn = props?.knn;
    this.nestedFilters = props?.nestedFilters ?? and()
  }

  override get isPostBody(): boolean {
    return true;
  }

  override getHttpParamsMap(): Record<string, any> {
    return {
      ...super.getHttpParamsMap(),
      aggregations: this.aggregation.map(it => ({ field: it, topHits: it === this.groupBy })),
      knn: this.knn,
      analytics: false,
      filter: this.nestedFilters?.toJSON() ?? { and: [] }
    };
  }
}


